export default __webpack_public_path__ + "static/media/attentionman.bba2910a.png";